import request from '@/utils/request'

export function fetchBuilds(query) {
  return request({
    url: '/builds',
    method: 'get',
    params: query
  })
}


export function fetchBuild(id) {
  return request({
    url: `/builds/${id}`,
    method: 'get'
  })
}


export function createBuild(data) {
  return request({
    url: '/builds',
    method: 'post',
    data
  })
}

export function updateBuild(id, data) {
  return request({
    url: `/builds/${id}`,
    method: 'put',
    data
  })
}


export function deleteBuild(id) {
  return request({
    url: `/builds/${id}`,
    method: 'delete'
  })
}

export function fetchBuildsContracts(query) {
  return request({
    url: '/builds/contracts',
    method: 'get',
    params: query
  })
}